"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var exifService_1 = require("./exifService");
var setCanvasDimensions = function (canvas, orientation, fixImageOrientation, scaledHeight, scaledWidth) {
    if (orientation > 4 && orientation < 9 && fixImageOrientation) {
        canvas.width = scaledHeight;
        canvas.height = scaledWidth;
    }
    else {
        canvas.width = scaledWidth;
        canvas.height = scaledHeight;
    }
};
var correctExifRotation = function (context, orientation, height, width) {
    switch (orientation) {
        case 2:
            context.transform(-1, 0, 0, 1, width, 0);
            break;
        case 3:
            context.transform(-1, 0, 0, -1, width, height);
            break;
        case 4:
            context.transform(1, 0, 0, -1, 0, height);
            break;
        case 5:
            context.transform(0, 1, 1, 0, 0, 0);
            break;
        case 6:
            context.transform(0, 1, -1, 0, height, 0);
            break;
        case 7:
            context.transform(0, -1, -1, 0, height, width);
            break;
        case 8:
            context.transform(0, -1, 1, 0, 0, width);
            break;
        default:
            break;
    }
};
var create = function (file, image, scale, _a) {
    var fixImageOrientation = _a.fixImageOrientation, transparencyFillColor = _a.transparencyFillColor;
    return __awaiter(void 0, void 0, void 0, function () {
        var canvas, context, scaledHeight, scaledWidth, orientation_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    canvas = document.createElement('canvas');
                    context = canvas.getContext('2d');
                    if (!context) return [3 /*break*/, 2];
                    scaledHeight = image.height * scale;
                    scaledWidth = image.width * scale;
                    return [4 /*yield*/, exifService_1.default.determineOrientation(file)];
                case 1:
                    orientation_1 = _b.sent();
                    setCanvasDimensions(canvas, orientation_1, fixImageOrientation, scaledHeight, scaledWidth);
                    if (fixImageOrientation) {
                        correctExifRotation(context, orientation_1, scaledHeight, scaledWidth);
                    }
                    context.fillStyle = transparencyFillColor;
                    context.fillRect(0, 0, scaledWidth, scaledHeight);
                    context.drawImage(image, 0, 0, scaledWidth, scaledHeight);
                    return [2 /*return*/, canvas];
                case 2: throw new Error('Could not get CanvasRenderingContext2D from HTMLCanvasElement.');
            }
        });
    });
};
exports.default = {
    create: create,
};
